import { Subject, interval, throttle } from 'rxjs';
import { initRemoteSettings, onSettingsLoadingStateChanged, onSettingsReady, settingsState } from "../settings/index.js";
import { LoadedState } from "../shared/index.js";
import { initTracker, onTrackerLoadingStateChanged, onTrackerReady, trackerState } from "../tracker/index.js";
import { loadBrowserSdks } from "./core-loader.js";
const state = {
    app: '',
    app_version: '0',
    cid: '',
    sdk: {
        settings: {
            state: settingsState,
            onLoadingStateChanged: onSettingsLoadingStateChanged,
            onReady: onSettingsReady,
            init: initRemoteSettings
        },
        tracker: {
            state: trackerState,
            onLoadingStateChanged: onTrackerLoadingStateChanged,
            init: initTracker,
            onReady: onTrackerReady
        }
    }
};
const retryLoad$ = new Subject();
const retryLoad = retryLoad$.pipe(throttle(() => interval(100))).subscribe((sdks) => {
    loadBrowserSdks(sdks, state).catch((err) => {
        console.log(err);
    });
});
function retryLoadSDKs(sdks) {
    retryLoad$.next(sdks);
}
function sdksScriptsEdded() {
    let added = false;
    const script = checkIfScriptExists();
    if (script) {
        added = true;
    }
    return added;
}
function checkIfScriptExists() {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
        const script = scripts[i];
        const src = script.getAttribute('src');
        if (src &&
            src.match(/^(https?|http):\/\/[^/]+\/pulse\/[^/]+\/(module\/|nomodule\/)?pulse\.js/i)) {
            return true;
        }
    }
    return false;
}
const setFailedState = (sdks) => {
    return () => {
        sdks.forEach((sdk) => {
            var _a, _b;
            (_b = (_a = state.sdk[sdk]).onLoadingStateChanged) === null || _b === void 0 ? void 0 : _b.call(_a, LoadedState.FAILED_TO_LOAD_IN_BROWSER);
        });
    };
};
function setLoadedState(sdks) {
    sdks.forEach((sdk) => {
        var _a, _b;
        (_b = (_a = state.sdk[sdk]).onLoadingStateChanged) === null || _b === void 0 ? void 0 : _b.call(_a, LoadedState.LOADED);
    });
}
const initialize = ({ config, sdks, app }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!state.app) {
        state.app = app;
    }
    if (state.app_version === '0' && ((_a = config.tracker) === null || _a === void 0 ? void 0 : _a.version)) {
        state.app_version = (_b = config.tracker) === null || _b === void 0 ? void 0 : _b.version;
    }
    if (!state.cid && state.cid === '' && ((_c = config.tracker) === null || _c === void 0 ? void 0 : _c.cid)) {
        state.cid = (_d = config.tracker) === null || _d === void 0 ? void 0 : _d.cid;
    }
    const win = window;
    win._pulse = win._pulse || {};
    if (config.tracker) {
        win._pulse.c = config.tracker;
    }
    win.pulseInit = win.pulseInit || [];
    win.dataLayer = win.dataLayer || [];
    if (win.pulseFailedToLoad && !((_e = win === null || win === void 0 ? void 0 : win.pulse) === null || _e === void 0 ? void 0 : _e.tracker) && !((_f = win === null || win === void 0 ? void 0 : win.pulse) === null || _f === void 0 ? void 0 : _f.settingsFactory)) {
        setFailedState(sdks)();
    }
    else if (win.pulseFailedToLoad === undefined &&
        !((_g = win === null || win === void 0 ? void 0 : win.pulse) === null || _g === void 0 ? void 0 : _g.tracker) &&
        !((_h = win === null || win === void 0 ? void 0 : win.pulse) === null || _h === void 0 ? void 0 : _h.settingsFactory)) {
        win.document.addEventListener('pulseLoadFailed', setFailedState(sdks));
    }
    sdks.forEach((sdk) => {
        win.pulseInit.push({
            sdk: sdk,
            onReady: () => {
                win.document.removeEventListener('pulseLoadFailed', setFailedState(sdks));
                retryLoad.unsubscribe();
                retryLoad$.complete();
                state.sdk[sdk].onReady();
            }
        });
    });
    if (!sdksScriptsEdded()) {
        win.document.removeEventListener('pulseLoadFailed', setFailedState(sdks));
        const script = loadBrowserSdks(sdks, state);
        script
            .then(() => {
            setLoadedState(sdks);
        })
            .catch(() => {
            setFailedState(sdks)();
        });
    }
    return sdks.reduce((acc, sdk) => (Object.assign(Object.assign({}, acc), { [sdk]: state.sdk[sdk].init(config[sdk] || {}, () => retryLoadSDKs(sdks)) })), {});
};
export { state as appState, initialize as initializeBrowserPulse };
//# sourceMappingURL=core.js.map